import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import uuid from 'uuid';

import { Action } from '../../../../../../components/index';
import { addDownloadMedia } from '../../../../../../store/modules/articles/actions';
import { DownloadIcon } from '../../../../../../components/icon/solid';
import { MediaStyles } from '../styles';
import { VideoRef } from '../../../../../../types/items';

type Props = {
  video: VideoRef | null;
};

const DownloadAction = ({ video }: Props) => {
  const classes = MediaStyles();
  const dispatch = useDispatch();
  const isGeneratedStatics = Boolean(video?.generated_statics);

  const clickHandler = useCallback(() => {
    if (video !== null && video.ref.statics) {
      const staticVideo = video.ref.statics[video.ref.statics.length - 1];
      if (staticVideo) {
        const ext = staticVideo.url.split('.').pop();
        const fileName = `${video.ref.filename_base}.${ext}`;
        dispatch(
          addDownloadMedia({
            url: staticVideo.url,
            name: fileName,
            downloadId: uuid(),
            urlRequested: false,
          }),
        );
      }
    }
  }, [video, dispatch]);

  return (
    <Action
      disabled={!isGeneratedStatics}
      icon={<DownloadIcon className={classes.actionIcon} />}
      title="Download"
      onClick={clickHandler}
    />
  );
};

export default DownloadAction;
